import Layout from '@/layout/index.vue'
export const tenantRouter = [
  {
    path: '/tenant',
    activeMenu: '/tenant',
    resourceId: '19',
    parentId: null,
    meta: {
      title: '配置易管理',
      icon: 'el-icon-s-tools',
      activeMenu: '/tenant',
      menu: true,
      sort: 31
    },
    component: Layout,
    children: [
      {
        path: '/tenant/dataPage',
        resourceId: '1906',
        parentId: '19',
        component: () => import('@/views/tenant/dataPage/index.vue'),
        meta: {
          title: '数据页面生成',
          icon: 'el-icon-film',
          activeMenu: '/tenant/dataPage'
        }
      },
      {
        path: '/tenant/dataExplain',
        resourceId: '1907',
        parentId: '19',
        component: () => import('@/views/tenant/dataExplain/index.vue'),
        meta: {
          title: '数据说明维护',
          icon: 'el-icon-suitcase-1',
          activeMenu: '/tenant/dataExplain'
        }
      },
      {
        path: '/tenant/storyline',
        // resourceId: '1908',
        parentId: '19',
        component: () => import('@/views/tenant/uploadStory/index.vue'),
        meta: {
          title: '故事线上传',
          icon: 'el-icon-upload',
          activeMenu: '/tenant/storyline'
        }
      },
      {
        path: '/tenant/calcGroup',
        resourceId: '1908',
        parentId: '19',
        component: () => import('@/views/tenant/calcGroup/index.vue'),
        meta: {
          title: 'IAS运算组选择',
          icon: 'el-icon-upload',
          activeMenu: '/tenant/calcGroup'
        }
      },
      {
        path: '/tenant/moduleSelect',
        // resourceId: '1908',
        parentId: '19',
        name: 'moduleSelect',
        component: () => import('@/views/tenant/calcGroup/moduleSelect.vue'),
        meta: {
          title: '设定运算组',
          icon: 'el-icon-upload',
          activeMenu: '/tenant/calcGroup',
          hidden: true
        }
      },
      {
        path: '/tenant/authGroup',
        resourceId: '1903',
        parentId: '19',
        component: () => import(/* webpackChunkName: "authGroup" */ '@/views/tenant/authGroup/index.vue'),
        meta: {
          title: '权限组设定',
          icon: 'invest_planning_params',
          activeMenu: '/tenant'
        }
      },
      {
        path: '/tenant/roleSetting',
        name: 'tenantRoleSetting',
        component: () => import(/* webpackChunkName: "authSetting" */ '@/views/tenant/authGroup/authSetting.vue'),
        meta: {
          title: '权限设置',
          icon: 'el-icon-s-order',
          activeMenu: '/tenant',
          hidden: true
        }
      }
    ]
  }
]
